import { MarketUpdate } from './websocket-response.type'

export interface Market {
	marketId: string
	marketName: string
	marketStartTime: string
	inPlay?: boolean
	runners: Runner[]
	eventType: MarketEventType
	competition: Competition | null
	event: MarketEvent
	eventName?: string
	totalMatched?: number
	mc?: MarketUpdate | null
	/* eslint-disable @typescript-eslint/no-explicit-any */
	description?: Record<string, any>
	navIds: string[]
	topic?: string
	serviceId?: string
	eventId?: string
	descriptionPrefix?: string
	maxBet?: number | null
	minBet?: number | null
}

export interface Runner {
	selectionId: number
	runnerName: string
	handicap: number
	sortPriority: number
	handicapLabel?: string
	handicapValues?: number[]
	/* eslint-disable @typescript-eslint/no-explicit-any */
	metadata?: Record<string, any>
	status?: string | null
	maxBetSize?: number | null
	minBetSize?: number | null
}

export interface MarketEventType {
	id: string
	name: string
}

export interface MarketEvent {
	id: string
	name: string
	countryCode?: string | null
	openDate?: string | null
	timezone?: string | null
	venue?: string | null
}

interface Competition {
	id: string
	name: string
}

export interface PredictedBet {
	marketGroupId: string
	marketId: string
	marketName: string
	selectionId: number
	side: Side
	bettingType: string
	provider: MarketProvider
	averagePriceMatched: string | number
	fOdds?: number
	dfOdds?: number
	stake?: number
	rangeOdd?: number
	handicapValues?: number[]
	handicap: number
	runnerName?: string
}

export interface SportGroup {
	id: string
	name: string
	items: Market[]
}

export interface CompetitionGroup {
	id: string
	name: string
	items: Market[]
}

export type Side = 'BACK' | 'LAY'

export interface LadderData {
	ranges: string[]
	values: number[]
}

export enum MarketProvider {
	BF = 'BF',
	SB = 'SB',
}

export interface HiddenNavigationItem {
	NAV_ID: string
	TYPE: HiddenNavigationItemType
}

export enum HiddenNavigationItemType {
	EVENT_TYPE = 'EVENT_TYPE',
	EVENT = 'EVENT',
	GROUP = 'GROUP',
	RACE = 'RACE',
	MARKET = 'MARKET',
}
